import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../server";
import { Button, Checkbox, message, Table } from "antd";
import Token from "./token";

const Tokens = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState();
  const divRef = useRef(null);

  const getData = () => {
    setLoading(true);
    serverFetch("token")
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, []);

  const columns = [
    {title: "#", dataIndex: "id", width: 100 },
    {title: "Пор.", dataIndex: "idx", },
    {title: "Акт.", dataIndex: "active", render: value => <Checkbox checked={value}/> },
    {title: "Наименование", dataIndex: "name", width: 400 },
    {title: "Календарь", dataIndex: "calendarName", },
  ]

  const onClose = (refresh) => {
    setEditId();
    refresh && getData();
  }

  const divItem = editId != null && <Token id={editId} onClose={onClose} />
  const headerSize =  divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY) : 0;
  const tableWidth = (document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left) || 0;

  return<div>
    <div className="sport-form-title">
      <Button onClick={getData}>Обновить</Button>
      <Button onClick={() => setEditId(0)}>Новый</Button>
    </div>
    <div ref={divRef} style={{width: tableWidth}}>
      <Table
        dataSource={items}
        columns={columns}
        rowKey="id"
        loading={loading}
        size="small"
        pagination={false}
        scroll={{ y: tableHeight }}
        rowSelection={{ type: 'radio', selectedRowKeys: [editId], renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
        onRow={(record) => ({onClick: () => {setEditId(record.id)}})}
      /> 
    </div>
    {divItem}
  </div>
}

export default Tokens;